import React from 'react';

const TableHead = ({ children }): JSX.Element => {
  return (
    <thead style={{
      textAlign: 'left',
      height: '2rem',
    }}>
      {children}
    </thead>
  );
};

export default TableHead;
